import { useEffect, useState } from "react"
import { BasicPage } from "../../theme/Component/BasicPage"
import { _DocumentFactory, _IncomeDocument, _single } from "../../../core/services/dataBean/EntityCatalog";
import { YearSelector } from "../../../core/shared/inputs/YearSelector";
import { SelectAccountantConceptForIncomeDocument } from "./Components/SelectAccountantConceptForIncomeDocument";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectIncomeStateConstant } from "./Components/SelectIncomeStateConstant";
import { BasicButton } from "../../theme/Component/BasicButton";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { MonthConstantsEditor } from "../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { ListMenu } from "../../theme/Component/ListMenu";
import { Modal } from "../../theme/Component/Modal";
import { DocumentViewer } from "../../theme/Component/DocumentViewer";
import { Alert } from "../../theme/Component/Alert";
import { DropDown } from "../../theme/Component/DropDown";
import { ExportXLSL } from "../../theme/Component/ExportXLSX";
import { toast } from "react-toastify";
import { FileService } from "../../../core/services/FileService";
import { IncomeCompensationDocument } from "./IncomeCompensationDocument/IncomeCompensationDocument";
import { _CreateEgress, _IncomeAdjustment, _IncomeAdjustmentByValue, _ReverseAccIcomeDoc, _UpdateIcomeDoc } from "../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../theme/Input/InputDate";
import { CatalogByIncomeResponsible } from "../../Talentohumano/GestionTH/EmployeeContract/ConceptCatalogByProcess/DefineConceptCatalogCompensation/CatalogByIncomeResponsible/CatalogByIncomeResponsible";
import { SelectBusinessCore } from "../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectProject } from "../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { InputMoney } from "../../theme/Input/InputMoney";
import { BankAccountSelect } from "../../erp/cellEditor/BankAccount/BankAccountSelect";
import useModal, { MODAL_XL } from "../../theme/Component/hooks/useModal";

interface ResponseProps {
    Year: number;
    Month: number;
    AccConcept: number;
    CashFlow: number;
    IDAccount: number;
    State: number;
    Regexst: string
}

interface DocumenteReference {
    IDDocument: number;
    DocumentDate: string;
}

export const IncomeDocument = () => {

    const { instance, setLista, lista, bean, setBean } = useDataBean(_IncomeDocument);
    const paginador = usePaginator();
    const UpdateIcomeDoc = useDataBean(_UpdateIcomeDoc);
    const IncomeAdjustment = useDataBean(_IncomeAdjustment);
    const IncomeAdjustmentByValue = useDataBean(_IncomeAdjustmentByValue);
    const reverseicome = useDataBean(_ReverseAccIcomeDoc);
    const createEgress = useDataBean(_CreateEgress);
    const fileService = new FileService();

    const [docs, setDocs] = useState<any>([]);
    const [reference, setReference] = useState<Partial<DocumenteReference>>({})
    const [response, setReponse] = useState<Partial<ResponseProps>>({
        Year: _single.getCurrenYear(),
        State: 3
    })
    const [modalcomprobante, setModalcomprobante] = useState<any>({ name: 'Generar reversión de Comprobante de Ingreso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalrealizar, setModalrealizar] = useState<any>({ name: 'Realizar Pago de Compensación', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    const modalDocument = useModal("", MODAL_XL);
    const [modalgeneratecomp, setModalgeneratecomp] = useState<any>({ name: 'Generar compensación por ajuste al peso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgenerate, setModalgenerate] = useState<any>({ name: 'Generar compensación de ingreso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalconsultar, setModalconsultar] = useState<any>({ name: 'Consultar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Ver Comprobante de Ingreso', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getIncomeDocumentCatalog(
            response.Year,
            response.Month,
            response.AccConcept,
            response.CashFlow,
            response.IDAccount,
            response.State,
            response.Regexst,
            paginador.page,
            15
        ).then((resp) => {
            if (resp && resp.List) {
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityDoc = `${element.DataBeanProperties.Mnemonic ?? "N/A"} - ${element.DataBeanProperties.Consecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityACMDoc = `${element.DataBeanProperties.ACMMnemonic ?? "N/A"} - ${element.DataBeanProperties.ACMConsecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityBudget = `${element.DataBeanProperties.BudgetIDStr ?? "N/A"} - ${element.DataBeanProperties.BudgetIDName ?? "N/A"}`
                    element.DataBeanProperties.EntityAccountant = `${element.DataBeanProperties.AccountantIDStr ?? "N/A"} - ${element.DataBeanProperties.AccountantIDName ?? "N/A"}`
                    element.DataBeanProperties.DocumentYear = element.DataBeanProperties.DocumentDate.split('-')[0] ? Number(element.DataBeanProperties.DocumentDate.split('-')[0]) : null;

                    if (element.DataBeanProperties.LoanMediaContext) {
                        element.DataBeanProperties.URL = ` <a href="${fileService.getUrlFile(element.DataBeanProperties.LoanMediaContext, element.DataBeanProperties.LoanMedia)}" target='_blank'>DESCARGAR DOCUMENTO</a>`
                    } else {
                        element.DataBeanProperties.URL = "Sin Documento";
                    }
                });

                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
                console.log(resp.NumberOfPages);
            } else {
                setLista([]);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    const createDocumentIncomeAdjustment = () => {
        IncomeAdjustment.instance.createDocumentIncomeAdjustment(bean.IDIncomeDocument, bean.DocumentDate, IncomeAdjustment.bean.AccountantDate, IncomeAdjustment.bean.IDAccount, IncomeAdjustment.bean.IDBusinessCore, IncomeAdjustment.bean.IDProject, IncomeAdjustment.bean.Description, _single.getAccountID(), true).then(
            (resp) => {
                if (resp) {
                    setDocs(resp.DocumentURL);
                    toast.success('Documento generado');
                    setModalgeneratecomp({ ...modalgeneratecomp, view: false });
                    modalDocument.open("Documento de compensación por ajuste al peso");
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const createDocumentIncomeAdjustmentByValue = () => {
        IncomeAdjustmentByValue.instance.createDocumentIncomeAdjustmentByValue(bean.IDIncomeDocument, bean.DocumentYear, IncomeAdjustmentByValue.bean.AccountantDate, IncomeAdjustmentByValue.bean.IDIncomeResponsibleConcept, IncomeAdjustmentByValue.bean.IDAccount, IncomeAdjustmentByValue.bean.IDBusinessCore, IncomeAdjustmentByValue.bean.IDProject, IncomeAdjustmentByValue.bean.Description, IncomeAdjustmentByValue.bean.Value, _single.getAccountID(), true).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    setDocs(resp.DocumentURL)
                    toast.success('Creado')
                    setModalgenerate({ ...modalgenerate, view: false });
                    modalDocument.open("Ver Compensacion de Ingreso");
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const reverseAccountantIncomeDocument = () => {
        reverseicome.instance.reverseAccountantIncomeDocument(bean.IDDocument, bean.DocumentDate, reverseicome.bean.AccountantDate, reverseicome.bean.Description, _single.getAccountID()).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    setDocs(resp.DocumentURL)
                    toast.success('Creado')
                    setModalcomprobante({ ...modalcomprobante, view: false });
                    modalDocument.open("Documento de reversión")

                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDIncomeDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Referencia 1', property: 'Reference1', visible: true },
        { title: 'Referencia 2', property: 'Reference2', visible: true },
        { title: 'Referencia 3', property: 'Reference3', visible: true },
        { title: 'Nit Fuente de Ingreso', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero Fuente de Ingreso', property: 'AccountName', visible: true },
        { title: 'Comprobante de Ingreso', property: 'EntityDoc', visible: true },
        { title: 'Fecha del Comprobante de Ingreso', property: 'DocumentDate', visible: true },
        { title: 'Estado del Comprobante de Ingreo', property: 'DocumentState', visible: true },
        // { title: 'Documento de Detalle', property: 'EntityACMDoc', visible: true },
        // { title: 'Fecha del Documento de Detalle', property: 'ACMDocumentDate', visible: true },
        // { title: 'Estado del Documento de Detalle', property: 'ACMDocumentState', visible: true },
        { title: 'Consultar archivo de cargue masivo de créditos', property: 'URL', visible: true },
        { title: 'Valor de Ingreso', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Valor Compensado', property: 'CompensatedValue', visible: true, mask: MASK_MONEY },
        { title: 'No Crédito', property: 'IDLoanQuota', visible: true },
        { title: 'Cuenta Contable', property: 'EntityAccountant', visible: true },
        { title: 'Rubro Presupuestal', property: 'EntityBudget', visible: true },
        { title: 'Tipo de Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Estado del Ingreso', property: 'StateName', visible: true },
    ]

    const updateIncomeDocumentState = () => {
        UpdateIcomeDoc.instance.updateIncomeDocumentState(bean.IDDocument, bean.DocumentDate).then(
            (resp) => {
                if (resp) {
                    console.log(resp)
                    toast.success('Actualizado')
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const validar = () => {
        createEgress.setBean({})
        setModalrealizar({ ...modalrealizar, view: true });
    }

    const createEgressDocumentForIncomeDocument = () => {
        if (!bean.IDDocument) {
            toast.warning("Debe tener un Documento.");
            return;
        }
        if (!bean.DocumentDate) {
            toast.warning("Debe tener una Fecha de Documento.");
            return;
        }
        if (!createEgress.bean.AccountantDate) {
            toast.warning("Debe seleccionar una Fecha Contabilización.");
            return;
        }
        if (!createEgress.bean.IDAccount) {
            toast.warning("Debe seleccionar un Beneficiario del Pago.");
            return;
        }
        if (!createEgress.bean.IDBankingAccount) {
            toast.warning("Debe seleccionar una Entidad.");
            return;
        }
        if (!createEgress.bean.ToCompensateValue) {
            toast.warning("Debe seleccionar un Valor a Girar.");
            return;
        }
        createEgress.instance.createEgressDocumentForIncomeDocument(bean.IDDocument, bean.DocumentDate, createEgress.bean.AccountantDate, createEgress.bean.IDAccount, null, createEgress.bean.IDBankingAccount, createEgress.bean.ToCompensateValue, createEgress.bean.Description, _single.getAccountID()).then(
            (resp) => {
                if (resp) {
                    setDocs(resp.DocumentURL)
                    setModalrealizar({ ...modalrealizar, view: false });
                    modalDocument.open("Pago de Compensación")
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Comprobante de Ingreso', icono: 'ri-file-download-line', visible: true, evento: () => { getDocument(bean.IDDocument, bean.Mnemonic, bean.DocumentDate, "Comprobante de Ingreso") } },
            { titulo: 'Actualizar Estado', icono: 'ri-folder-upload-line', visible: true, evento: () => { updateIncomeDocumentState() } },
            { titulo: 'Generar compensación de ingreso', icono: 'ri-folder-upload-line', visible: true, evento: () => { setModalgenerate({ ...modalgenerate, "view": true }) } },
            { titulo: 'Generar compensación por ajuste al peso', icono: 'ri-folder-upload-line', visible: true, evento: () => { setModalgeneratecomp({ ...modalgeneratecomp, "view": true }) } },
            { titulo: 'Realizar Pago de Compensación', icono: 'ri-folder-upload-line', visible: true, evento: () => { validar() } },
            { titulo: 'Generar reversión de Comprobante de Ingreso', icono: 'ri-send-plane-fill', visible: true, evento: () => { setModalcomprobante({ ...modalcomprobante, "view": true }) } },
            { titulo: 'Consultar Operaciones de Compensación', icono: 'ri-edit-2-line', visible: true, evento: () => { setModalconsultar({ ...modalconsultar, "view": true }) } },
            { titulo: 'Ver Comprobante de Detalle', icono: 'ri-file-download-line', visible: bean.ACMIDDocument, evento: () => { getDocument(bean.ACMIDDocument, bean.ACMMnemonic, bean.ACMDocumentDate, "Comprobante de Detalle") } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const getDocument = (idDoc: number, mnemonic: string, docDate: any, modalName: string) => {
        instance.getPdfAccountantDocument(idDoc, mnemonic, docDate).then(
            (resp) => {
                setReference({ IDDocument: idDoc, DocumentDate: docDate });
                setDocs(resp);
                console.log(resp)
                setModal({ ...modal, "view": true, "name": modalName });
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    useEffect(() => {
        setDocs([]);
        setReference({});
    }, [bean])

    const [modalCSV, setModalCSV] = useState<any>({ name: 'Detallado', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-md' });
    const [listaExport, setListaExport] = useState([]);

    const getListaExport = () => {
        instance.getIncomeDocumentCatalog(response.Year, response.Month, response.AccConcept, response.CashFlow, response.IDAccount, response.State, response.Regexst, 1, paginador.pages * 15).then(
            (resp) => {
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityDoc = `${element.DataBeanProperties.Mnemonic ?? "N/A"} - ${element.DataBeanProperties.Consecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityACMDoc = `${element.DataBeanProperties.ACMMnemonic ?? "N/A"} - ${element.DataBeanProperties.ACMConsecutive ?? "N/A"}`
                    element.DataBeanProperties.EntityBudget = `${element.DataBeanProperties.BudgetIDStr ?? "N/A"} - ${element.DataBeanProperties.BudgetIDName ?? "N/A"}`
                    element.DataBeanProperties.EntityAccountant = `${element.DataBeanProperties.AccountantIDStr ?? "N/A"} - ${element.DataBeanProperties.AccountantIDName ?? "N/A"}`
                });
                setListaExport(resp.List)
            }
        ).catch(
            err => { console.log(err) }
        )
    }


    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {lista.length > 0 &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }


    const actions = (e: any) => {

        if (e.id === 1) {
            getListaExport();
            setModalCSV({ ...modalCSV, "view": true });
        }
    }

    return (
        <BasicPage titulo="Comprobantes de Ingreso" >
            <div className="row">
                <div className="col-md-6">
                    <YearSelector tittle="Año" onChange={(e) => { setReponse({ ...response, "Year": e }) }} value={response.Year} />
                </div>
                <div className="col-md-6">
                    <MonthConstantsEditor name="" idSelect={response.Month} onChange={(e) => { setReponse({ ...response, "Month": e }) }} label="Mes" />
                </div>
                <div className="col-md-6">
                    <SelectAccountantConceptForIncomeDocument idSelector={response.AccConcept} onChange={(e) => { setReponse({ ...response, "AccConcept": e }) }} />
                </div>
                <div className="col-md-6">
                    <label >Concepto de Flujo de Caja</label>
                    <input type="number" className="form-control" value={response.CashFlow} onChange={(e) => { setReponse({ ...response, "CashFlow": parseFloat(e.target.value) }) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor idAccount={response.IDAccount} label="Responsable" onChange={(e) => { setReponse({ ...response, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-6">
                    <SelectIncomeStateConstant idSelector={response.State} onChange={(e) => { setReponse({ ...response, "State": e }) }} />
                </div>
                <div className="col-md-6">
                    <label >Texto de búsqueda</label>
                    <input type="text" className="form-control" value={response.Regexst} onChange={(e) => { setReponse({ ...response, "Regexst": e.target.value }) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={getLista} icon="ri-serch-line" children={"Buscar"} />
                </div>

                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} />
                </div>
            </div>

            <Modal modal={modalconsultar} updateModal={setModalconsultar} >
                <IncomeCompensationDocument IDDocument={bean.IDDocument} DocumentDate={bean.DocumentDate} />
            </Modal>

            <Modal modal={modalcomprobante} updateModal={setModalcomprobante} eventModal={reverseAccountantIncomeDocument}>
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha Contabilización" name="AccountantDate" value={reverseicome.bean.AccountantDate} setDate={(e) => { reverseicome.setBean({ ...reverseicome.bean, "AccountantDate": e }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={reverseicome.bean.Description} onChange={reverseicome.handleChange} />

                    </div>
                </div>
            </Modal>

            <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={createDocumentIncomeAdjustmentByValue}>
                <div className="row">
                    <div className="col-md-6">
                        <InputDate label="Fecha Contabilización" name="AccountantDate" value={IncomeAdjustmentByValue.bean.AccountantDate} setDate={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "AccountantDate": e }) }} />
                    </div>
                    {/* <div className="col-md-6">
                                    <YearSelector tittle="Año" onChange={(e) => { setgeneratebean({ ...generatebean, "Year": e }) }} value={form.Year} />
                                </div> */}
                    <div className="col-md-6">
                        <label>Concepto Contable de Ajuste</label>
                        <CatalogByIncomeResponsible render={IncomeAdjustmentByValue.bean.IncomeResponsibleName} idSelector={IncomeAdjustmentByValue.bean.IDIncomeResponsibleConcept} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDIncomeResponsibleConcept": e.IDIncomeResponsibleConcept, "IncomeResponsibleName": e.Name, "IDBusinessCore": e.IDBusinessCore, "IDProject": e.IDProject }) }} label=" " returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor label="Tercero" idAccount={IncomeAdjustmentByValue.bean.IDAccount} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                    </div>
                    <div className="col-md-6">
                        <InputMoney _value={IncomeAdjustmentByValue.bean.Value} onChange={(e: any) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, 'Value': e }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={IncomeAdjustmentByValue.bean.IDBusinessCore} onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDBusinessCore": e.Code }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectProject label='Proyecto' idSelector={IncomeAdjustmentByValue.bean.IDProject} returnType="Object" onChange={(e) => { IncomeAdjustmentByValue.setBean({ ...IncomeAdjustmentByValue.bean, "IDProject": e.IDProject }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={IncomeAdjustmentByValue.bean.Description} onChange={IncomeAdjustmentByValue.handleChange} />

                    </div>
                </div>
            </Modal>


            <Modal modal={modalrealizar} updateModal={setModalrealizar} eventModal={createEgressDocumentForIncomeDocument}>
                <div className="row">
                    <div className="col-md-6">
                        <InputDate label="Fecha de Registro Contable" name="accountantDate" value={createEgress.bean.AccountantDate} setDate={(e) => { createEgress.setBean({ ...createEgress.bean, "AccountantDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor label="Tercero" idAccount={createEgress.bean.IDAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                    </div>
                    <div className="col-md-6">
                        <BankAccountSelect label='Entidad' idSelector={createEgress.bean.IDBankingAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDBankingAccount": e }) }} />
                        {/* <BakingEntityEditor label="Entidad Bancaria" idSelector={createEgress.bean.IDBankingAccount} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "IDBankingAccount": e }) }} /> */}
                    </div>
                    <div className="col-md-6">
                        <InputMoney _label="Valor a Girar" _value={createEgress.bean.ToCompensateValue} onChange={(e) => { createEgress.setBean({ ...createEgress.bean, "ToCompensateValue": e }) }} />

                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={createEgress.bean.Description} onChange={createEgress.handleChange} />

                    </div>
                </div>
            </Modal>

            <Modal modal={modalgeneratecomp} updateModal={setModalgeneratecomp} eventModal={createDocumentIncomeAdjustment}>
                <div className="row">
                    <div className="col-md-6">
                        <InputDate label="Fecha Contabilización" name="AccountantDate" value={IncomeAdjustment.bean.AccountantDate} setDate={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "AccountantDate": e }) }} />
                    </div>
                    {/* <div className="col-md-6">
                                    <YearSelector tittle="Año" onChange={(e) => { setgeneratebean({ ...generatebean, "Year": e }) }} value={form.Year} />
                                </div> */}
                    {/* <div className="col-md-6">
                            <label>Concepto Contable de Ajuste</label>
                            <CatalogByIncomeResponsible render={IncomeAdjustment.bean.IncomeResponsibleName} idSelector={IncomeAdjustment.bean.IDIncomeResponsibleConcept} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDIncomeResponsibleConcept": e.IDIncomeResponsibleConcept, "IncomeResponsibleName": e.Name, "IDBusinessCore": e.IDBusinessCore, "IDProject": e.IDProject }) }} label=" " returnType="Object" />
                        </div> */}
                    <div className="col-md-6">
                        <AccountEditor label="Tercero" idAccount={IncomeAdjustment.bean.IDAccount} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                    </div>
                    <div className="col-md-6">
                        <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={IncomeAdjustment.bean.IDBusinessCore} onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDBusinessCore": e.Code }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectProject label='Proyecto' idSelector={IncomeAdjustment.bean.IDProject} returnType="Object" onChange={(e) => { IncomeAdjustment.setBean({ ...IncomeAdjustment.bean, "IDProject": e.IDProject }) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={IncomeAdjustment.bean.Description} onChange={IncomeAdjustment.handleChange} />

                    </div>
                </div>
            </Modal>

            <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} evenOnClose={() => { setDocs([]) }} >
                {Array.isArray(docs) && docs.length > 0 ?
                    <DocumentViewer list={docs} IDDocument={reference.IDDocument} Since={reference.DocumentDate} />
                    :
                    <Alert children={"No se genero ningun documento"} clase="warning text-center" />
                }
            </Modal>

            <Modal modal={modalCSV} updateModal={setModalCSV}>
                <div className="row">
                    <div className="col">
                        {listaExport.length > 0 &&
                            <ExportXLSL customName={"CuentasXPagar"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </div>
                </div>
            </Modal>

        </BasicPage >
    )
}